import L from 'leaflet';
import { debounce } from './modules/utilities.js';

const dixon_map = document.getElementById('dixon-map');

var yx = L.latLng;

var xy = function(x, y) {
    if (L.Util.isArray(x)) {    // When doing xy([x, y]);
        return yx(x[1], x[0]);
    }
    return yx(y, x);  // When doing xy(x, y);
};

window._xy = xy;


const bounds = [xy(0, 0), xy(1237, 978)];


const map = L.map( dixon_map, {
    crs: L.CRS.Simple,
    attributionControl: false,
    zoomSnap: 0,
    minZoom: -2,
    dragging: !L.Browser.mobile,
    tap: !L.Browser.mobile,
    maxZoom: 2,
    center: L.latLngBounds(bounds).getCenter(),
    scrollWheelZoom: false,
});

// window._dixon_map = map;

const icon = L.Icon.extend({
    options: {
        iconUrl: '/assets/images/dixon-map-marker.svg',
        shadowUrl: false,
        iconSize: [16, 16],
        iconAnchor: [8, 8],
        popupAnchor: [0, -8]
    }
});

const dixonIcon = new icon();


global.markers.forEach(element => {

    let markerInfo =
    `
        <div>
            ${element.info.image ? '<img src="' + element.info.image + '" />' : ''}
            <div class="p-2">
                <h2 class='text-2p4 border-b border-solid pb-1 mb-1'>${element.info.title}</h2>
                <div class="text-1p4">
                    ${element.info.artist ? '<p class="!mt-0 !mb-p5 font-bold">' + element.info.artist + '</p>' : ''}
                    ${element.info.date ? '<p class="!mt-0 !mb-p5">' + element.info.date + '</p>' : ''}
                    ${element.info.medium ? '<p class="!mt-0 !mb-p5">' + element.info.medium + '</p>' : ''}
                    ${element.info.dimensions ? '<p class="!mt-0 !mb-p5">' + element.info.dimensions + '</p>' : ''}
                    ${element.info.description ? '<p class="!mt-0 !mb-p5">' + element.info.description + '</p>' : ''}
                    ${element.info.note ? '<p class="!mt-0 !mb-p5 text-1">' + element.info.note + '</p>' : ''}
                    ${element.info.link ? '<a class="map-link" href="' + element.info.link + '">' + element.info.linkText + '</a>' : ''}
                </div>
            </div>
        </div>
    `;
    L.marker(
        element.coordinates,
        {
            icon: dixonIcon
        }
    )
    .addTo(map)
    .bindPopup(
        markerInfo,
        {
            minWidth: 250
        }
    );
});

const dixon_map_image = L.imageOverlay('/assets/images/Dixon_Map-2021-web.svg', bounds ).addTo(map);

// set map to fit within containers size
map.fitBounds(bounds);

map.on('resize', debounce(() => {
    map.fitBounds(bounds);
}, 250));
